import React, { useState } from 'react'
import { toast } from 'react-toastify'

import {
    Button,
    Divider,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    useTheme,
} from '@material-ui/core'

import { Container } from '../../components'
import { AreaType, AreaConfig } from '../../models'
import { CreateAreaConfigRequest } from '../../store'
import { typographyStyle } from '../../theme/typographyStyle'

interface Props {
    onClose: () => void
    apartmentId: number
    createAreaConfig: (
        request: CreateAreaConfigRequest,
        apartmentId: number,
    ) => Promise<AreaConfig>
}

export const CreateAreaConfigForm = (props: Props) => {
    const theme = useTheme()
    const [name, setName] = useState('')
    const [validate, setValidate] = useState(false)
    const [areaType, setAreaType] = useState<AreaType>(AreaType.COM)

    return (
        <Container style={{ height: 400, width: 400, flexDirection: 'column' }}>
            {/* Title area */}
            <Container style={{ padding: theme.spacing(1) }}>
                <span
                    style={{
                        ...typographyStyle(theme.typography.h5),
                        fontWeight: 700,
                    }}
                >
                    Create Area Config
                </span>
            </Container>
            <Divider />

            <Container
                style={{ flexDirection: 'column', padding: theme.spacing(1) }}
            >
                <TextField
                    variant="outlined"
                    label="Name (Required)"
                    error={validate && name === ''}
                    value={name}
                    onChange={(e) => {
                        setName(e.target.value)
                    }}
                    style={{ marginBottom: theme.spacing(1) }}
                />

                <FormControl
                    style={{ margin: theme.spacing(2, 0), width: '100%' }}
                >
                    <InputLabel id="area-type-label">Area Type</InputLabel>
                    <Select
                        id={`area-type-select`}
                        value={areaType}
                        onChange={(e) => {
                            setAreaType(e.target.value as AreaType)
                        }}
                        label="Area Type"
                        title="Area Type"
                        style={{ width: '100%' }}
                    >
                        {Object.values(AreaType).map((value) => {
                            return (
                                <MenuItem key={value} value={value}>
                                    {value.charAt(0) +
                                        value.substring(1).toLocaleLowerCase()}
                                </MenuItem>
                            )
                        })}
                    </Select>
                </FormControl>
            </Container>
            <div style={{ flex: 1 }} />
            <Divider />
            <Container style={{ padding: theme.spacing(1) }}>
                <div style={{ flex: 1 }} />
                <Button
                    variant="outlined"
                    color="secondary"
                    style={{ marginRight: theme.spacing(1) }}
                    onClick={props.onClose}
                >
                    Cancel
                </Button>
                <Button
                    variant="outlined"
                    color="primary"
                    onClick={async () => {
                        if (name === '') {
                            setValidate(true)
                            return
                        }

                        const req: CreateAreaConfigRequest = {
                            body: {
                                name: name,
                                area_type: areaType,
                                shows_on_schedule: false,
                            },
                        }

                        try {
                            await props.createAreaConfig(req, props.apartmentId)
                            toast.success(`${name} Created.`)
                            setName('')
                            props.onClose()
                        } catch (error) {
                            toast.error('Failed to create area config')
                        }
                    }}
                >
                    Create
                </Button>
            </Container>
        </Container>
    )
}
